import { prefixPluginTranslations } from "@strapi/helper-plugin";
import pluginPkg from "../../package.json";
import pluginId from "./pluginId";
import Initializer from "./components/Initializer";
import { WidenLibrary } from "./components/WidenLibrary";
const name = pluginPkg.strapi.name;
export default {
  async register(app) {
    app.addComponents([{
      name: "widen-library",
      Component: await WidenLibrary
    }]);
    app.registerPlugin({
      id: pluginId,
      initializer: Initializer,
      isReady: false,
      name
    });
  },
  bootstrap(app) {}
};